<template>
<el-container id="home-main">
  <div>
    <publicHeader @hotelLanguage="hotelLanguage"></publicHeader>
    <div class="interceptingBody">
      <div class="icon">
        <img src="/static/img/intercepting.png"/>
        <div class="iconText">{{$t('AccountSecurityWarning')}}</div>
      </div>
      <div class="content">
        {{$t('interceptingTextOne')}}<br/>
        {{$t('interceptingTextTwo')}}
        <!-- <a href="/question/contactUs?" style="color: rgb(83, 146, 249); font-weight: 650; cursor: pointer;">{{$t('interceptingTextTwoContactOur')}}</a> -->
        <router-link :to="{name:'contactUs', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" style="color: rgb(83, 146, 249); font-weight: 650; cursor: pointer;">
            {{$t('contactUs')}}
          </router-link>
        {{$t('interceptingTextTwoCustomerServiceTeam')}}<br/>
        {{$t('interceptingTextThree')}}
      </div>
    </div>
  </div>
  <publicFooter :languageSet="language"></publicFooter>
</el-container>
</template>

<script scoped>
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
export default {
  name: 'Home',
  components: {
    publicFooter,
    publicHeader
  },
  props: [],
  data () {
    return {
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      source: 'roompai',
      conver: ''
    }
  },
  created: function () {},
  mounted: function () {
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      localStorage.removeItem('source')
      localStorage.removeItem('sourceExpiresAt')
    }

    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
  },
  watch: {},
  beforeDestroy () {},
  methods: {
    hotelLanguage (language) {
      this.language = language
    }
  }
}
</script>
<style type="text/css" scoped>
 .interceptingBody {
   height: 65vh;
   display: grid;
   line-height: 25px;
   font-size: 18px;
   font-family: PingFangSC-Regular,PingFang SC,sans-serif;
   font-weight: 400;
   margin-top: 100px;
   justify-items: center;
   align-content: center;
 }
 .icon {
   display: flex;
   margin-bottom: 30px;
   justify-content: center;
   align-items: center;
 }
 .icon img {
   height: 50px;
   display: inline-block;
   text-align: center;
   line-height: normal;
   text-transform: none;
   margin-right:8px;
 }
 .iconText {
   background: inherit;
   background-color: rgba(255, 255, 255, 0);
   border: none;
   border-radius: 0px;
   -moz-box-shadow: none;
   -webkit-box-shadow: none;
   box-shadow: none;
   font-weight: 600;
   font-style: normal;
   font-size: 18px;
   color: #EC808D;
   display: inline-block;
 }

 .content {
   width: 40%;
   display: inline-block;
   font-style: normal;
   font-size: 14px;
   letter-spacing: 1px;
   color: #4F4C4C;
   line-height: 30px;
   margin-bottom: 30px;
   text-align: center;
 }

 @media only screen and (max-width:1099px){
   .interceptingBody {
     width: 90%;
     height: 50vh;
     text-align: center;
     margin: 100px auto;
     line-height: 17px;
     font-size: 14px;
     font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
     font-weight: 400;
   }
   .content {
     width: 100%;
     display: inline-block;
     font-style: normal;
     font-size: 14px;
     letter-spacing: 1px;
     color: #4F4C4C;
     line-height: 30px;
     margin-bottom: 30px;
     text-align: left;
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/Intercepting.vue